import React from "react";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../stores/calculateStore";
import { SeniorProposalModel } from "../../../helpers/seniorProposalModel";
import Header from "../../sharedComponents/header/header";
import Pesel from "../../sharedComponents/pesel/pesel";
import FirstName from "../../sharedComponents/firstName/firstName";
import LastName from "../../sharedComponents/lastName/lastName";
import Address from "../../sharedComponents/address/address";



interface SeniorProps {
    calculateStore?: CalculateStore;
    senior: SeniorProposalModel;
    headerText: string;
}

export function Senior(props: SeniorProps) {
    return (
        <div className="section senior">
            <Header type="medium" mainHeader={props.headerText} />
            <FirstName firstName={props.senior.firstName} />
            <LastName lastName={props.senior.lastName} />
            <Pesel pesel={props.senior.pesel} />
            <Header type="small" mainHeader="Adres zamieszkania" />
            <Address address={props.senior.address} displayLabel={true}/>
        </div>
    );
}

export default inject("calculateStore")(observer(Senior));
